module.exports = __webpack_public_path__ + "img/type_collection_icon.e06403d2.svg";